// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --c=TextMATCH-production` replaces `environment.ts` with `environment.TextMATCH.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  cognitoSettings: {
    UserPoolId: 'ap-southeast-2_utgj1f0aq', // e.g. us-east-2_uXboG5pAb
    ClientId: '6j5f0ttlo96t5i21fcj059rke9', // e.g. 25ddkmj4v6hfsfvruhpfi7n4hv
    region: 'ap-southeast-2' // e.g. us-east-2
  },

  APIBaseURL: 'https://apis.dev.auckland.ac.nz/proxy-textmatch-v1',

  projectName: 'TextMATCH_Lakes',
  projectVersion: '1.0.0',
  timezone: 'Pacific/Auckland',


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
